interface LogoProps {
  className?: string;
}

export function LuxuryFundLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M13.5,36.8c.2-3.4,2.8-7.2,8-8.5-.9,5.4-4.4,8.2-8,8.5M13.2,13.8c3.3.4,6.8,3,8,8.1-5.1-1-7.9-4.6-8-8.1M24.6,24.9c0-1-.1-1.9-.3-2.8-1.1-5.6-5.4-9.3-11.1-9.4.3-3.1,2.6-6.6,7.5-7.9v-.6h-6.4v.9c.3,0,.6.2.6.5s-2.1,3.3-2.4,7.1c0,.3,0,.6,0,.8h0c0,5.2,3.4,9.9,9.1,11.1.6.1,1.2.2,1.9.3-.6,0-1.3.1-1.9.3-5.5,1.2-9.2,5.5-9.2,11.2v.3c0,.2,0,.5,0,.7.2,2.9,1.2,5.6,2.8,8.1l5.6.4v-.7c-4.1-.9-7.4-3.3-7.5-7.8,5.2-.2,9.8-3.7,10.9-9.6.1-.9.2-1.7.2-2.7v-.2h0c0-.1,0-.1,0-.1Z" 
      />
      <path 
        fill="currentColor" 
        d="M46,21h.6v-6.4h-.9c0,.3-.2.6-.5.6s-3.4-2.2-7.3-2.4c0,.2,0,.5,0,.7,3.2.2,6.8,2.5,8.1,7.6" 
      />
      <path 
        fill="currentColor" 
        d="M46.8,29.1h-.7c-.9,4.1-3.4,7.5-8,7.5h-.3c0,.3,0,.6,0,1,3.1-.1,6-1.2,8.6-2.9l.4-5.6h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M3.9,29.3h-.6v6.4h.9c0-.3.2-.6.5-.6s3.4,2.2,7.3,2.4c0-.2,0-.5,0-.7-3.2-.2-6.8-2.5-8.1-7.6" 
      />
      <path 
        fill="currentColor" 
        d="M36.6,36.5c-3.3-.5-7-3.2-8.1-8.4,5.3,1,8.1,4.7,8.1,8.4M36.3,13.4c-.4,3.3-2.9,6.9-7.9,8.2,1-5.2,4.4-7.9,7.9-8.2M37.3,13.5h0c0-.3,0-.5,0-.8-.2-3-1.2-5.8-2.8-8.4l-5.6-.4v.7c4.1.9,7.5,3.4,7.5,8h0c-5.1.3-9.7,3.7-10.9,9.5-.2.9-.3,1.9-.3,2.9h0c0,1.1,0,2,.3,2.9,1.1,5.8,5.4,9.6,11.1,9.6-.4,3.1-2.7,6.3-7.5,7.6v.6h6.4v-.9c-.3,0-.6-.2-.6-.5s2-3.1,2.4-6.8c0-.3,0-.6,0-1v-.2c0-5.2-3.4-9.9-9.1-11.1-.6-.1-1.2-.2-1.9-.3.6,0,1.3-.2,1.9-.3,5.5-1.2,9.2-5.5,9.2-11.2" 
      />
      <path 
        fill="currentColor" 
        d="M11.8,13.7h.3c0-.4,0-.7,0-.9-3.1.1-6,1.2-8.6,2.9l-.4,5.6h.7c.9-4.1,3.4-7.5,8-7.5" 
      />
    </svg>
  );
}